import React from 'react';
import StatementGeneration from '../components/StatementGeneration';


export default function Statements() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <main>
        <StatementGeneration />
      </main>
    
    </div>
  );
}
